export default __webpack_public_path__ + "static/media/logo.137a6169.png";